import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseService} from '../../_helpers';
import {CarEntity} from '../entity';

@Injectable({
  providedIn: 'root'
})
export class CarService extends BaseService<CarEntity> {

  constructor(protected http: HttpClient) {
    super('config/cars', CarEntity);
  }
}
